export default "__VITE_ASSET__tklk_YZq__"